<template>
  <div class="toolbar">
    <br />
    <div class="feature-intro title">
      <h1>Dependencia</h1>
    </div>
    <div>
      <TemplateTable
        tableTitle="Dependencia"
        reference="dependencia"
        :loading="loading"
        v-on:selectItem="$emit('selectItem', $event)"
        :idTable="idTable"
        :url="url"
        :data="data"
        apiversion="v2"
        :modal="modal"
        :keyShow="keyShow"
        :filtersFields="filtersFields"
        :multiSelect="true"
        :enableSelectAllCheckbox="true"
        :enableEditButtons="true"
        :enableGlobalSearch="false"
        :enableFilterMultiple="true"
        :enableAddButton="{ enabled: true, route: '/dependencia/add' }"
      />
    </div>
    <!-- <div class="ml-5">
        <Button label="Seleccionar" @click="submit"/>
      </div> -->
    <!-- POR AHORA,  enableGlobalSearch REQUIERE QUE enableEditButtons SEA TRUE!!-->
    <!-- <button>submit</button> -->
  </div>
</template>

<script>
// import axios from 'axios'

export default {
  name: "DependenciaList",
  props: {
    modal: {
      type: Boolean,
    },
  },
  data() {
    return {
      filteredLocation: [],
      url: process.env.VUE_APP_BACKEND_ENVIRONMENT + "/parametros/dependencia",
      customName: [],
      data: null,
      customColumn: [],
      idTable: "DependenciaID",
      loading: true,
      filtersFields: [
        { name: "Nombre", field: "Nombre" },
        { name: "Admitesumarios", field: "Admitesumarios" },
      ],
      keyShow: [
        "Admitesumarios",
        "Descripcion",
        "Nombre",
        "Telefonos",
        "DependenciaLetra",
        "Interno",
        "ClavePolicial",
        "DependenciatipoID",
        "DepositodependenciaID",
        "DomicilioID",
        "ImpresionEncabezado",
        "Domicilio",
      ],
    };
  },
  methods: {
    submit() {
      let userTableData = this.$refs.tableData.getTableData();
      this.$setCookie("userDependencia", userTableData.Nombre);
      this.$setCookie("userDependenciaID", userTableData.UsuarioID);
      this.$router.push({ path: "/gestionUsers" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  margin-left: 30px;
}
</style>
